exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-block[data-v-8098fbf6]{border-bottom:1px solid var(--black-light-2);padding-bottom:24px;margin-left:-24px;margin-right:-24px}aside.zb-modal.slide-in-modal.active.pull-top-0[data-v-8098fbf6]{top:0!important}@media(min-width:601px)and (max-width:1200px){.title-block[data-v-8098fbf6]{padding-top:24px;margin-left:0;margin-right:0;padding-left:24px;padding-right:24px}}@media(max-width:600px){.title-block[data-v-8098fbf6]{margin-left:0;margin-right:0;padding:24px}}", ""]);

// exports
